module.exports = __webpack_public_path__ + "img/idealgaming.10dacf49.png";